setTimeout(() => {
    // Integration into existing code may break the current functionality. It was decided to make an add-on in a specific place.
    const reviewsProduct = document.querySelector(".product__info-wrapper .review-items-container");
    if (reviewsProduct) {
        const slideshowWrapper = reviewsProduct.querySelector(".slideshow ");
        const slideshowSlides = slideshowWrapper.querySelectorAll(".slideshow__slide");
        slideshowSlides.forEach(slide => {
            if (slide.getAttribute("aria-hidden") == "false") {
                slideshowWrapper.style.height = slide.querySelector(".review-item").clientHeight + "px";
            }
            const config = {
                attributes: true,
                attributeFilter: ["aria-hidden"],
            };
            const observer = new MutationObserver((mutationsList, observer) => {
                mutationsList.forEach(mutation => {
                    if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
                            if (slide.getAttribute("aria-hidden") == "false") {
                                slideshowWrapper.style.height = slide.querySelector(".review-item").clientHeight + "px";
                            }
                    }
                });
            });
            observer.observe(slide, config);
        });
    }
}, 1);